import React from 'react';
import { Link } from 'react-router-dom';

import SectionIcon from '../../icons/SectionIcon';

function SplashHero() {
  const icons = [
    {
      theme: 'patient-care',
      label: 'Patient Safety',
    }, {
      theme: 'pharmacy',
      label: 'Pharmacy',
    }, {
      theme: 'nursing',
      label: 'Nursing',
    }, {
      theme: 'anesthesia',
      label: 'Anesthesia',
    },
  ];
  return (
    <div className="splash-hero">
      <div className="splash-hero__intro-wrapper row">
        <div className="splash-hero__text-wrapper">
          <h2 className="splash-hero__heading">
            Identify barriers to providing injectable medications in the most ready-to-administer (RTA) form possible
          </h2>
          <Link to="login" className="button button--brand button--large">
            Start New Assessment
          </Link>
        </div>
        <div className="splash-hero__image-wrapper">
          <img className="splash-hero__image" src="/img/RTA-Tool_iPad Mockup.png" alt="" />
        </div>
      </div>
      <div className="row">
        <div className="splash-hero__icons">
          {icons.map(icon => (
            <div className="splash-hero__icon" key={icon.label}>
              <SectionIcon theme={icon.theme} />
              <div className="splash-hero__icon-label">
                {icon.label}
              </div>
            </div>
          ))}
        </div>
        <div className="splash-hero__description text">
          <p>
            The tool is composed of four modules designed to help hospitals in assessing the challenges and barriers and prioritizing and developing corrective action plans to improve the safety of injectable medications.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SplashHero;



// WEBPACK FOOTER //
// ./src/components/features/splash/SplashHero.js